// OneID konfiguratsiyasi va auth URL'ini yasash uchun helper.
function resolveRedirectUri() {
  if (typeof window === "undefined") {
    return "https://govcontrol.uz/cabinet";
  }
  const href = window.location.href;
  if (href.indexOf("https://govcontrol.uz") > -1) {
    return "https://govcontrol.uz/cabinet";
  }
  if (href.indexOf("http://govcontrol.uz") > -1) {
    return "http://govcontrol.uz/cabinet";
  }
  if (href.indexOf("govcontrol.uz") > -1) {
    return window.location.origin + "/cabinet";
  }
  return window.location.origin + "/cabinet";
}

const OneIdConfig = {
  baseUrl: "https://sso.egov.uz/sso/oauth/Authorization.do",
  clientId: "govcontrol_uz",
  redirectUri: resolveRedirectUri(),
  scope: "govcontrol_uz",
  responseType: "one_code",
};

export function BuildOneIdAuthUrl(state) {
  const params = new URLSearchParams({
    response_type: OneIdConfig.responseType,
    client_id: OneIdConfig.clientId,
    redirect_uri: OneIdConfig.redirectUri,
    scope: OneIdConfig.scope,
    state: state || "",
  });
  return `${OneIdConfig.baseUrl}?${params.toString()}`;
}

export function GenerateState() {
  return (
    Math.random()
      .toString(36)
      .substring(2, 15) +
    Math.random()
      .toString(36)
      .substring(2, 15)
  );
}

export default OneIdConfig;
